export class Relation {
  constructor(
    public parent: string,
    public child: string,
    public direction: '_include' | '_revinclude',
    public path: string,
    public _count?: string | number,
    public _fieldslist?: string,
    public cardinality?: string,
    public _page?: number,
    public excludeFromBundle?: boolean
  ) {
  }
}

export class Target {
  constructor(
    public _count: string | number,
    public _page: number = 0,
    public _fieldslist?: string,
    public _countOnly?: boolean,
    public _forceFilter?: boolean,
    public _forceOrder?: boolean,
    public _forceTargetPage?: boolean,
    public _preAuthorized?:boolean,
    public _grpKey?: string
  ) {
  }
}

export class Filter {
  resource: string;
  operator?: string;
  value: string;
  path: string;
  type?: string;
  root?: boolean;
  parentId?: string;
  excludeFromBundle?: boolean;

  constructor(resource: string, operator: string, value: string, path: string, type?: string, root?: boolean) {
    this.resource = resource;
    this.operator = operator;
    this.value = value;
    this.path = path;
    this.type = type;
    this.root = root;
  }
}

export interface IdashboardFilter {
  id: string;
  label: string;
  defaultEnabled?: boolean;
  type: 'toggle' | 'dropdown';
  filters: Array<Filter>;
}

export class Sort {
  resource: string;
  path: string;
  direction: string;
  type?: string;
  aggregate?: string;

  constructor(resource: string, path: string, direction: string, type?: string, aggregate?: string) {
    this.resource = resource;
    this.path = path;
    this.direction = direction;
    this.aggregate = aggregate;
    this.type = type;
  }
}

export class DynamicSearchPayload {
  constructor(
    public target: Target,
    public relations?: Relation[],
    public filters?: Filter[],
    public sort?: Sort[],
    public recursiveGrouping?: boolean,
    public resourceNeedsFlatten?: any[], // TODO need to remove until fixing DY node js
    public useSort?: boolean
  ) {
  }
}

export class BundleDynamicSearchPayload {
  constructor(
    public resource: string,
    public searchType: DynamicSearchType,
    public searchBody: DynamicSearchPayload
  ) {
  }
}

export enum DynamicSearchType {
  statistics = 'statistics',
  id = 'id',
  data = 'data',
  relations = 'relations',
  clubbed = 'clubbed',
}
